export enum ROLES {
    SUPERADMIN = 1,
    ADMIN = 2,
    DIRECTOR = 3,
    BIBLIOTECARIO = 4,
    ESTUDIANTE = 5,
    PADRE = 6,
    VENDEDOR = 7,
    DISTRIBUIDOR = 8,
    CLIENTE = 9,
    INTERNO = 10,
    EXTERNO = 11
  }
